<ion-row class="exanded-row-container">
  <ion-col size="5" class="col-padding left-col">
    <form [formGroup]="form">
      <p class="form-title">{{ CONSTANTS.TRACKING_NUMBER }}</p>
      <ion-radio-group
        class="radio-group"
        formControlName="type"
        ngDefaultControl
      >
        <ion-item lines="none" class="item">
          <ion-radio slot="start" value="hazmat" class="radio-btn"></ion-radio>
          <ion-label class="btn-label">{{ CONSTANTS.HAZMAT }}</ion-label>
        </ion-item>
        <ion-item lines="none" class="item">
          <ion-radio slot="start" value="dryIce" class="radio-btn"></ion-radio>
          <ion-label class="btn-label">{{ CONSTANTS.DRY_ICE }}</ion-label>
        </ion-item>
      </ion-radio-group>
      @if (form.get("type")?.value === "dryIce") {
        <div class="dry-ice-details">
          <!-- <ion-item lines="none"> -->
          <app-form-input-field
            [label]="CONSTANTS.AMOUNT"
            formControlName="dryIceAmountOne"
            [maxLength]="3"
            [required]="true"
            class="dry-ice-amount-one"
            (keypress)="
              commonUtils.preventSpecialCharacters(
                $event,
                SpecialCharacters.NUMBER_ONLY
              )
            "
          ></app-form-input-field>
          .
          <app-form-input-field
            [maxLength]="2"
            formControlName="dryIceAmountTwo"
            [required]="false"
            class="dry-ice-amount-two"
            (keypress)="
              commonUtils.preventSpecialCharacters(
                $event,
                SpecialCharacters.NUMBER_ONLY
              )
            "
          ></app-form-input-field>
          <!-- </ion-item> -->

          <!-- <ion-item> -->
          <app-form-select
            [label]="CONSTANTS.UNIT_OF_MEASURE"
            [options]="UNITS"
            formControlName="unitOfMeasure"
            [required]="true"
          ></app-form-select>
          <!-- </ion-item> -->
        </div>
      }

      <div class="tracking-number-container">
        <ion-item
          class="tracking-number-item"
          lines="none"
          [ngClass]="{
            'has-error':
              form.get('trackingNumbers')?.invalid &&
              form.get('trackingNumbers')?.value &&
              (form.get('trackingNumbers')?.touched ||
                form.get('trackingNumbers')?.dirty),
          }"
        >
          <ion-textarea
            formControlName="trackingNumbers"
            class="form-textarea"
            type="text"
            maxlength="18"
            [placeholder]="CONSTANTS.ENTER_TRACKING_NUMBER"
            (keypress)="commonUtils.preventSpecialCharacters($event)"
            [autoGrow]="true"
            cols="1"
          ></ion-textarea>
          <ion-button
            slot="end"
            fill="clear"
            class="upload-btn"
            (click)="fileUpload()"
          >
            <ion-icon [src]="SRC.UPLOAD" class="btn-icon"></ion-icon>
            <span class="btn-text"> {{ CONSTANTS.FILE_UPLOAD }} </span>
          </ion-button>
        </ion-item>
        <div class="action-bar">
          <ion-button
            class="submit-btn"
            [disabled]="form.invalid"
            (click)="submit()"
          >
            {{ CONSTANTS.SUBMIT }}
          </ion-button>
        </div>
      </div>
      @if (
        form.get("trackingNumbers")?.invalid &&
        form.get("trackingNumbers")?.value &&
        (form.get("trackingNumbers")?.touched ||
          form.get("trackingNumbers")?.dirty)
      ) {
        <p class="error-msg">
          {{ CONSTANTS.INVALID_TRACKING_NUMBER }}
        </p>
      }
    </form>
  </ion-col>
  <ion-col size="6" class="right-col">
    <div class="seprator" [ngClass]="{ 'seprator-small': true }"></div>

    <div class="tracking-no-list" [ngClass]="{ 'small-list': true }">
      @if (!isFileUpload) {
        <div class="header">
          <p class="title custom-col col-1">{{ CONSTANTS.TRACKING_NUMBER }}:</p>
          <p class="title custom-col col-2">{{ CONSTANTS.STATUS }}:</p>
          <p class="title custom-col">{{ CONSTANTS.REASON }}:</p>
          <p class="title custom-col col-4">{{ CONSTANTS.FLEX }}:</p>
        </div>
        <div class="body">
          @for (item of trackingNumberData; track item; let index = $index) {
            <div class="custom-row">
              <div class="item custom-col col-1">{{ item.trackingNumber }}</div>
              <div class="item custom-col col-2">{{ item.status }}</div>
              <div class="item custom-col">{{ item.reason }}</div>
              <div class="item custom-col col-4">{{ item.flex }}</div>
              <div class="item custom-col">
                <ion-button
                  fill="clear"
                  class="delete-btn"
                  (click)="
                    removeTrackingNumberConfirmDialog(
                      item.trackingNumber,
                      index
                    )
                  "
                >
                  <ion-icon [src]="SRC.DELETE" class="icon"></ion-icon>
                </ion-button>
              </div>
            </div>
          }
        </div>
      }
      <div class="footer">
        <div class="counter-container">
          <div class="counter-label">{{ CONSTANTS.ULD_COUNT }}:</div>
          <div class="counter">{{ uldCount }}</div>
        </div>
        <div class="counter-container">
          <div class="counter-label">{{ CONSTANTS.LOOSE_COUNT }}:</div>
          <div class="counter">{{ looseCount }}</div>
        </div>
      </div>
    </div>
  </ion-col>
</ion-row>
